module.exports = __webpack_public_path__ + "img/service1.ed108f6f.jpg";